module.exports = __webpack_public_path__ + "static/media/ico_time.ae2b1b9b.svg";